import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import useTrialExp from "../components/useTrialExp";

const getViewportBucket = () => {
  if (typeof window === "undefined") return "desktop";
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1280) return "tablet";
  return "desktop";
};

const Layout = ({ children, hideHeader = false, hideSidebar = false, dashboardOnly = false }) => {
  const { guard, Popup } = useTrialExp();
  const [sidebarExpanded, setSidebarExpanded] = useState(() => getViewportBucket() === "desktop");

  useEffect(() => {
    if (typeof window !== "undefined" && window.self !== window.top) {
      const orgId = localStorage.getItem("orgId");
      if (orgId && orgId !== "undefined" && orgId !== "null") {
        localStorage.setItem("portalTenantView", "1");
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const bucket = getViewportBucket();
      if (bucket === "tablet") {
        setSidebarExpanded(false);
      } else if (bucket === "desktop") {
        setSidebarExpanded(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (e) => {
    // guard logic...
  };

  return (
    <div
      className="nyafaz-admin-layout app-layout flex h-screen overflow-hidden"
      onClick={handleClick}
      style={{
        background: "var(--app-background)",
      }}
    >
      {!hideSidebar && (
        <Sidebar
          dashboardOnly={dashboardOnly}
          expanded={sidebarExpanded}
          setExpanded={setSidebarExpanded}
        />
      )}
      <div
        className={`layout-content flex h-full w-full min-w-0 flex-col overflow-y-auto overflow-x-hidden transition-all duration-500 ${
          !hideSidebar ? (sidebarExpanded ? "layout-content--expanded" : "layout-content--collapsed") : ""
        }`}
      >
        <div className="layout-main flex min-h-full w-full min-w-0 flex-1 flex-col px-4 md:px-5 lg:px-6">
          {!hideHeader && <Header showLogo={hideSidebar} />}
          {!hideSidebar && (
            <div className="layout-breadcrumb pt-3 md:pt-4">
              <Breadcrumb />
            </div>
          )}
          <div className="page-shell flex flex-1 flex-col pb-5 pt-4 md:pb-6 md:pt-5">{children}</div>
        </div>
      </div>

      <Popup />
    </div>
  );
};

export default Layout;
